module.exports = __webpack_public_path__ + "static/media/20.8f81bd57.png";